module.exports = __webpack_public_path__ + "fa-brands-400.a9afdb72826cde196ddf.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.woff2
// module id = ./src/assets/webfonts/fa-brands-400.woff2
// module chunks = styles